import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useFetchProductsBySku from '../../../hooks/useFetchProductsBySku';

const useProductDetails = (optionData, productLinks = []) => {
  const [skus, setSkus] = useState([]);
  const { storeId } = useSelector(state => ({
    storeId: state.store.id
  }));

  useEffect(
    () => {
      if (optionData.fetchDetails && productLinks) {
        setSkus(productLinks.map(link => link.sku));
      }
    },
    [optionData.id]
  );

  const { loading, data } = useFetchProductsBySku(
    storeId,
    skus,
    process.env.RAZZLE_CMS_SITE
  );

  return { loading, data };
};

export default useProductDetails;
